export class MasterDeliveryRoute {
    ID: number;
    Code: string;
    SalesOfficeNumber: string;
    DistributionChannel: string;
    Inactive?: boolean;
}

export default MasterDeliveryRoute;